import logger from '../utils/rbmc.logger';
import gigyaCustom from './rbmc.gigya';
import pdpTooltips from '../pdp/rbmc.pdp-tooltips';
import urlUtils from '../utils/rbmc.url-utils';

// screen ids
const CDC_CHANGE_PASSWORD_SCREEN      = 'gigya-change-password-screen',
      CDC_UPDATE_PROFILE_SCREEN       = 'gigya-update-profile-screen',
      CDC_MANAGE_SUBSCRIPTIONS_SCREEN = 'gigya-manage-subscriptions-screen';

const gigyaCustomUpdateProfile = {
    $newsletterCheckbox: undefined,
    isSubscribed:        false,
    $body: undefined,
    $2stepUnsubscribeBtn: undefined,
    $2stepUnsubscribeSuccess: undefined,
    $2stepUnsubscribeNoSubscription: undefined,
    $2stepUnsubscribeFailed: undefined,

    bindHandler:         () => {
        document.addEventListener('gigya-profile-update-after-screenload', gigyaCustomUpdateProfile.onScreenLoaded);
        document.addEventListener('gigya-profile-update-after-submit', gigyaCustomUpdateProfile.updateProfileAfterSubmit);
        document.addEventListener('gigya-profile-update-before-submit', gigyaCustomUpdateProfile.updateProfileBeforeSubmit);
        document.addEventListener('gigya-profile-update-submit', gigyaCustomUpdateProfile.updateProfileOnSubmit);
        document.addEventListener('gigya-profile-update-field-change', gigyaCustomUpdateProfile.updateProfileAfterFieldChange);
    },

    cacheSelectors() {
        this.$body = $('body');
        this.$2stepUnsubscribeBtn = this.$body.find('#js-2-step-unsubscribe');
        this.$2stepUnsubscribeSuccess = this.$body.find('.newsletter__unsubscribe-message--success');
        this.$2stepUnsubscribeNoSubscription = this.$body.find('.newsletter__unsubscribe-message--no-sub');
        this.$2stepUnsubscribeFailed = this.$body.find('.newsletter__unsubscribe-message--failed');
    },

    bindEvents() {
        this.$2stepUnsubscribeBtn.on('click', gigyaCustomUpdateProfile.twoStepNewsletterUnsubscribe);
    },

    onScreenLoaded:                evt => {
        const data = evt.detail;
        // PASWORD SCREEN LOADED
        if (data.currentScreen === CDC_CHANGE_PASSWORD_SCREEN) {
            $('input[name="newPassword"]:visible').parent().append(
                    `<span class="gigya-error-msg d-none pass-validation-msg gigya-error-msg-active">
                        ${$('.gigya-password--invalid').text()}
                    </span>`);

            gigyaCustom.showPasswordCheckbox();
        }

        // NEWSLETTER SUBSCRIPTION SCREEN LOADED
        if (data.currentScreen === CDC_MANAGE_SUBSCRIPTIONS_SCREEN) {
            gigyaCustomUpdateProfile.$newsletterWrapper  = $('#cdc-gigya-manage-subscriptions-container');
            gigyaCustomUpdateProfile.$newsletterCheckbox = $('.gigya-screen-content .gigya-newsletter-subscribe--main input');

            //add specific class to parent row to manage visibility later
            $('.gigya-element-marker').closest('.gigya-layout-row').addClass('checkbox-row');
            $('.gigya-newsletter-language').closest('.gigya-layout-row').addClass('checkbox-row');
            $('.gigya-newsletter-birth').closest('.gigya-layout-row').addClass('checkbox-row');
            $('.gigya-input-submit').attr('disabled', true);
            gigyaCustomUpdateProfile.subscriptionInitialMessages(gigyaCustomUpdateProfile.$newsletterCheckbox);
            gigyaCustomUpdateProfile.isSubscribed = gigyaCustomUpdateProfile.$newsletterCheckbox.prop('checked');
            gigyaCustomUpdateProfile.$newsletterCheckbox.addClass('checkbox-switch')
                                    .on('change', gigyaCustomUpdateProfile.updateNewsletterSettings)
                                    .prop('checked') ?
                    gigyaCustomUpdateProfile.subscriptionInterestsShow() :
                    gigyaCustomUpdateProfile.subscriptionInterestsShow(false);

            gigyaCustomUpdateProfile.$newsletterCheckbox.after(`<span class='checkbox-switch-button'></span>`);

            // bind tooltip to switch button
            gigyaCustomUpdateProfile.bindTooltip('.checkbox-switch-button');
            gigyaCustomUpdateProfile.changedInterests();

        }
    },
    updateProfileAfterFieldChange: evt => {
        const data         = evt.detail,
              $newPassword = $('input[name="newPassword"]:visible'),
              regExp       = new RegExp(".{8,}");

        if (data.screen === CDC_CHANGE_PASSWORD_SCREEN) {
            if (!$newPassword.val().match(regExp) && $newPassword.val() !== "") {
                $newPassword.siblings('.pass-validation-msg').removeClass('d-none');

                //set class after cdc refresh form field
                setTimeout(() => $newPassword.addClass('gigya-error'), 400);
            } else {
                $newPassword.siblings('.pass-validation-msg').addClass('d-none');
                $newPassword.removeClass('gigya-error');
            }
        }

        // be aware there are always two inputfields with the same name in the DOM (one is hided by CDC)
        let $targetInput           = $('.gigya-screen-content [name="' + data.field + '"]');
        let $gigyaCompositeControl = $targetInput.closest('.gigya-composite-control');

        if (data.isValid) {
            $gigyaCompositeControl.removeClass('gigya-composite-control--error')
        } else {
            $gigyaCompositeControl.addClass('gigya-composite-control--error')
        }

    },

    updateProfileBeforeSubmit: evt => {
        const data = evt.detail;
        if (data.screen === CDC_MANAGE_SUBSCRIPTIONS_SCREEN) {
            if (!gigyaCustomUpdateProfile.$newsletterCheckbox.prop('checked')) {
                gigyaCustomUpdateProfile.$newsletterWrapper
                                        .find('.checkbox-row input')
                                        .prop('checked', false);
            }
        }
    },

    updateProfileOnSubmit: event => {
        gigyaCustom.clearEmailForLoggedIn(event);
    },

    updateNewsletterSettings: evt => {
        const checkboxValue            = $(evt.currentTarget),
              $newsletterSwitchTooltip = $('.checkbox-switch-button');
        // current status of checkbox switch
        if (checkboxValue.prop('checked') === false) {
            if (gigyaCustomUpdateProfile.isSubscribed) {
                $newsletterSwitchTooltip.tooltip('show');
                $('.checkbox-switch ').prop('checked', true);
            } else {
                gigyaCustomUpdateProfile.subscriptionInterestsShow(false);
            }
        } else {
            gigyaCustomUpdateProfile.subscriptionInterestsShow();
            $('.gigya-input-submit').attr('disabled', false);
            gigyaCustomUpdateProfile.updateNsStatusMsg(document.getElementById("saveChangeMsgsaveChangeMsg").innerText);
        }
    },

    updateNsStatusMsg(text) {

        if (typeof text != "string") {
            console.error("Trying to update ns status with something else than String");
            return;
        }

        var nsSubscriptionStatus       = document.querySelector('main .gigya-newsletter-subcribe-status');
        nsSubscriptionStatus.innerText = text;
    },

    bindTooltip: elem => {
        const $cdcForm = $('#gigya-profile-form');
        $cdcForm.find(elem).tooltip({
            placement: 'right',
            html:      true,
            trigger:   'manual',
            container: elem,
            title:     pdpTooltips.tooltipTemplate(
                    $cdcForm.find('.gigya-newsletter-subcribe-tooltip-msg span').data('tooltip-title'),
                    $cdcForm.find('.gigya-newsletter-subcribe-tooltip-msg span').data('tooltip-confirm'),
                    $cdcForm.find('.gigya-newsletter-subcribe-tooltip-msg span').data('tooltip-cancel'),
                    'newsletterCancelTooltip'
            )
        }).tooltip('update');

        const $checkboxSwitch = $('.checkbox-switch ');
        $cdcForm.find(elem).on('click', '.tooltip-buttons .btn-secondary', () => { //cancel
            $cdcForm.find(elem).tooltip('hide');
        }).on('click', '.tooltip-buttons .btn-primary', () => { // confirm
            gigyaCustomUpdateProfile.subscriptionInterestsShow(false);
            gigyaCustomUpdateProfile.$newsletterWrapper.find('.checkbox-row input').prop('checked', false);

            // show appeal to save changes

            gigyaCustomUpdateProfile.updateNsStatusMsg(document.getElementById("saveChangeMsgsaveChangeMsg").innerText);

            $checkboxSwitch.prop('checked', false);
            $('.gigya-input-submit').attr('disabled', false);
            $cdcForm.find(elem).tooltip('hide');
        });
    },

    subscriptionInitialMessages() {

        function updateSubscriptionMessage(response) {

            var nsSubscriptionStatus = document.querySelector('main .gigya-newsletter-subcribe-status');

            if (response.errorCode != 0) {
                console.error("Cannot obtain ns subscription status");
                nsSubscriptionStatus.innerText = typeof response.errorMessage === "string" ? response.errorMessage : "Error";
                return;
            }

            var isSubscribed = response.subscriptions.newsletter.email.isSubscribed;
            var isPending    = response.subscriptions.newsletter.email.doubleOptIn.status === "Pending";

            if (typeof isSubscribed != "boolean") {
                // response does not contain expected field!
                console.error("CDC response does not contain expected field!");
                return;
            }

            if (!isSubscribed) {
                nsSubscriptionStatus.innerText = document.getElementById("notSubscribedInfoMsg").innerText;
            } else if (isPending) {
                nsSubscriptionStatus.innerText = document.getElementById("pendingInfoMsg").innerText;
            } else {
                nsSubscriptionStatus.innerText = document.getElementById("subscribedInfoMsg").innerText;
            }
        }

        gigya.accounts.getAccountInfo({include: "subscriptions", callback: updateSubscriptionMessage});
    },

    subscriptionInterestsShow: (boolean = true) => {
        const checkboxRow = $('.checkbox-row');
        boolean ? checkboxRow.show() : checkboxRow.hide()
    },

    changedInterests: () => {
        gigyaCustomUpdateProfile.$newsletterWrapper.on('change', '.checkbox-row input, .checkbox-row select', () => {
            $('.gigya-input-submit').attr('disabled', false);
        });
    },

    updateProfileAfterSubmit: evt => {
        let data = evt.detail;
        $.ajax(`${ACC.config.encodedContextPath}/gigyaraas/profile`, {
            data:     {
                gigyaData: JSON.stringify(data)
            },
            dataType: "json",
            type:     "post"
        });

        gigyaCustomUpdateProfile.redirect(data);
    },

    redirect: data => {

        let cdcResponseStatus = data.response.status;

        // an error on form validation occurred
        if (cdcResponseStatus === 'FAIL') {
            // do nothing, form should show error message
            return false;
        } else if (cdcResponseStatus === 'OK') {

            if (data.screen === CDC_CHANGE_PASSWORD_SCREEN || data.screen === CDC_UPDATE_PROFILE_SCREEN) {
                // remove all possible current parameters and add new
                window.location.href = `${window.location.pathname}?success=true`;
            }

            if (data.screen === CDC_MANAGE_SUBSCRIPTIONS_SCREEN) {
                gigyaCustomUpdateProfile.subscriptionInitialMessages();
                gigyaCustomUpdateProfile.isSubscribed = gigyaCustomUpdateProfile.$newsletterCheckbox.prop('checked');
                $('.gigya-input-submit').attr('disabled', true);
            }

        } else {
            logger.log(`Error: unexpected status returned from CDC server, response is ${cdcResponseStatus}`);
        }
    },

    twoStepNewsletterUnsubscribe() {
        const queryString = window.location.search;
        const token = new URLSearchParams(queryString).get('channelToken');
        gigyaCustomUpdateProfile.$2stepUnsubscribeBtn.prop('disabled', true);
        $.ajax({
            url: `${urlUtils.getBaseUrl()}/newsletter/unsubscribe-two-step/`,
            method: 'POST',
            cache: false,
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({channelToken: token})
        }).done((data) => {
            gigyaCustomUpdateProfile.twoStepMessageControl(data);
        }).fail((data) => {
            logger.log('Something went wrong with unsubscribe request');
            logger.log(data);
        }).always(() => {
            gigyaCustomUpdateProfile.$2stepUnsubscribeBtn.removeAttr('disabled');
        });
    },

    twoStepMessageControl(data) {
        const {errors, noSubscription, success} = data;
        const hideClass = 'd-none';

        gigyaCustomUpdateProfile.$2stepUnsubscribeBtn.addClass(hideClass);

        if (noSubscription) {
            this.$2stepUnsubscribeNoSubscription.removeClass(hideClass);
        }

        if (success) {
            this.$2stepUnsubscribeSuccess.removeClass(hideClass);
        }

        if (errors.length > 0) {
            this.$2stepUnsubscribeFailed.removeClass(hideClass);
        }
    },
};

$(() => {
    gigyaCustomUpdateProfile.cacheSelectors();
    gigyaCustomUpdateProfile.bindEvents();
});

export default gigyaCustomUpdateProfile;
